{
  "platform": {
    "create": {
      "formExamples": {
        "nameEn": "Example Retail Group",
        "nameAr": "مجموعة متاجر المثال",
        "slug": "example-retail",
        "adminName": "e.g. Example Administrator",
        "adminEmail": "administrator@example.test"
      },
      "notAvailableTitle": "Not available for your role",
      "notAvailableBody": "Creating an organisation and inviting its first administrator needs a role that includes provisioning.",
      "refusedTitle": "The organisation was not created",
      "missing": {
        "nameEn": "Enter the organisation's name in English.",
        "nameAr": "Enter the organisation's name in Arabic.",
        "slug": "Enter an identifier.",
        "adminName": "Enter the administrator's name.",
        "adminEmail": "Enter the administrator's email address."
      }
    },
    "org": {
      "invitationState": {
        "expired": "Invitation expired",
        "revoked": "Invitation revoked",
        "none": "No invitation on record"
      },
      "invitationExpiredOn": "Invitation expired on",
      "historyLatest": "Showing the latest {{count}} events",
      "historyOlder": "Show older events"
    },
    "pilotStatus": {
      "planned": "Planned",
      "configuring": "Being configured",
      "ready": "Ready",
      "live": "Live",
      "completed": "Completed",
      "converted": "Converted",
      "expired": "Expired",
      "cancelled": "Cancelled"
    },
    "subscriptionStatus": {
      "draft": "Draft",
      "active": "Active",
      "past_due": "Past due",
      "suspended": "Suspended",
      "cancelled": "Cancelled",
      "expired": "Expired"
    },
    "orgs": {
      "allAdministrators": "All administrators",
      "pendingActivation": "Not yet activated"
    },
    "controlPlane": {
      "scope": "Commercial administration and organisation readiness. Customer procurement remains in its own portal.",
      "plans": "Plans",
      "subscriptions": "Subscriptions",
      "capacity": "Entitlements and capacity",
      "addons": "Add-ons",
      "commercial": "Commercial",
      "operations": "Support operations",
      "audit": "Audit",
      "noAccess": "Your role does not include this area.",
      "pinned": "Published versions are immutable. Existing subscriptions keep their assigned version until an authorised change is applied.",
      "editPlan": "Edit plan",
      "createPlan": "Create plan",
      "planDefinition": "Plan definition",
      "retire": "Retire plan",
      "activate": "Activate plan",
      "active": "Active",
      "retired": "Retired",
      "versions": "Versions",
      "newVersion": "New draft version",
      "version": "Version {{version}}",
      "published": "Published",
      "draft": "Draft",
      "editVersion": "Edit draft",
      "publish": "Publish version",
      "searchPlans": "Search plans",
      "emptyFiltered": "No matching records",
      "noPlans": "No plans",
      "code": "Code",
      "planUpdated": "Plan updated: {{name}}.",
      "versionPublished": "Version {{version}} published. Existing subscriptions are unchanged.",
      "priceUnspecified": "Price not specified",
      "savePlan": "Save plan",
      "planSaved": "Plan saved: {{name}}.",
      "publicPlan": "Visible in the public catalogue",
      "required": "This field is required.",
      "refused": "The change could not be saved",
      "reason": "Reason",
      "reasonRequired": "Enter a reason for this change.",
      "reasonPlaceholder": "Explain why this commercial change is needed.",
      "planCodeHint": "Use letters, numbers, hyphens or underscores.",
      "formExamples": {
        "code": "PLAN-EXAMPLE",
        "name_en": "Example Growth Plan",
        "name_ar": "مثال: خطة النمو",
        "description_en": "A plan for organisations with multiple purchasing units.",
        "description_ar": "خطة للمنشآت التي تضم وحدات شراء متعددة."
      },
      "currency": "Commercial currency",
      "basePrice": "Base price",
      "billingPeriod": "Billing period",
      "saveVersion": "Save draft",
      "entitlements": "Entitlements",
      "notImplemented": "Technical capability not available",
      "implemented": "Technical capability available",
      "enabled": "Included",
      "disabled": "Not included",
      "limit": "Limit",
      "capacityMeaning": "Commercial capacity counts the active purchasing units. Add-ons widen eligible limits by the greatest applicable limit, not by summing them.",
      "assignSubscription": "Assign subscription",
      "searchSubscriptions": "Search subscriptions",
      "filterSubscriptions": "Filter subscriptions",
      "context": "Commercial context",
      "selectedRecord": "Selected record",
      "noSubscriptions": "No subscriptions",
      "subscriptionUpdated": "Subscription updated",
      "suspendSubscription": "Suspend subscription",
      "reinstateSubscription": "Reinstate subscription",
      "accessNow": "Access now",
      "available": "Available",
      "unavailable": "Unavailable",
      "contract": "Contract",
      "noContract": "No contract linked",
      "changePlan": "Change plan",
      "adjustCapacity": "Adjust capacity",
      "commercialVsTechnical": "Commercial inclusion does not establish technical availability. Both are shown separately.",
      "changes": "Change requests",
      "approveChange": "Approve change",
      "applyChange": "Apply change",
      "cancelChange": "Cancel change",
      "subscriptionStateEffect": "This changes subscription access. Organisation lifecycle is managed separately.",
      "authoritativeMoment": "The server determines the effective event. Reductions wait for renewal; held changes require the existing domain conditions to be met.",
      "before": "Before",
      "previousSubscription": "Previous subscription",
      "after": "After",
      "proposed": "Proposed",
      "held": "This change is held. Review its commercial conditions before applying.",
      "wholeCapacity": "Enter a whole number from 0 to 2147483647.",
      "targetCapacity": "Proposed capacity",
      "reviewChange": "Review change",
      "proposeChange": "Submit change request",
      "versionLabel": "Published plan version",
      "activeContractOnly": "Choose an active, current contract for this organisation that is not linked to another subscription.",
      "operationsReadOnly": "Scheduler health and completed runs from the existing run records. No customer procurement records are shown.",
      "scheduler": "Scheduler",
      "schedulerAlive": "Scheduler is reporting",
      "schedulerMissing": "Scheduler has not reported recently",
      "noTasks": "No scheduler tasks",
      "task": "Task",
      "health": "Health",
      "lastSuccess": "Last success",
      "nextRun": "Next expected run",
      "runHistory": "Run history",
      "noRuns": "No runs recorded",
      "recordsChanged": "Records changed",
      "auditScope": "Commercial and platform administration events, with server-controlled redaction. Customer procurement is outside this view.",
      "periodLabel": "Event date window",
      "noAudit": "No events in this scope",
      "action": "Action",
      "occurred": "Occurred",
      "actor": "Actor",
      "system": "System",
      "platformGlobal": "Platform-wide",
      "noReason": "No reason recorded",
      "addonUpdated": "Add-on updated: {{name}}.",
      "effectiveNow": "Effective now",
      "notEffectiveNow": "Not effective now",
      "searchAddons": "Search add-ons",
      "noAddons": "No add-ons",
      "noVersions": "No versions",
      "noChanges": "No change requests",
      "noEntitlements": "No entitlements",
      "addon": "Add-on",
      "commercialAvailability": "Commercial availability",
      "technicalAvailability": "Technical availability",
      "sellable": "Available for subscription",
      "notSellable": "Not available for subscription",
      "subscribedAddons": "Subscribed add-ons",
      "attachAddon": "Attach add-on",
      "noAssignments": "No add-ons assigned",
      "scheduleRemoval": "Schedule removal",
      "chooseOrganisation": "Choose an organisation to view its add-ons.",
      "removalAtRenewal": "Removal takes effect at renewal; current access remains until the server-defined event.",
      "coterminousAddon": "The add-on must fit within the parent subscription window. Empty dates use that window.",
      "currentOrganisation": "Current organisation entitlements and capacity",
      "historicalScope": "This is a historical subscription. Its plan and contract belong to this record; entitlements and capacity describe the organisation now.",
      "includedCapacity": "Included capacity",
      "allocatedCapacity": "Allocated capacity",
      "admin": "Administrator",
      "readiness": "Readiness",
      "ready": "Ready",
      "needsSetup": "Needs setup",
      "filterOrganisations": "Filter organisations",
      "suspendOrganisation": "Suspend organisation",
      "reinstateOrganisation": "Reinstate organisation",
      "organisationStateEffect": "This changes the organisation lifecycle and access. It does not alter its subscription or commercial terms.",
      "organisationUpdated": "Organisation updated",
      "missingData": "Current information is not available yet.",
      "existingSubscription": "This organisation has an existing subscription. Use its change workflow.",
      "allocatedUnits": "Allocated purchasing units",
      "usedUnits": "Active purchasing units",
      "unlimitedOrganisations": "Unlimited organisations: {{count}}",
      "needsSetupCount": "Organisations needing setup",
      "capacityDefinition": "Finite allocations are counted separately from organisations with unlimited capacity.",
      "fields": {
        "code": "Plan code",
        "name_en": "Name in English",
        "name_ar": "Name in Arabic",
        "description_en": "Description in English",
        "description_ar": "Description in Arabic"
      },
      "period": {
        "unspecified": "Period not specified",
        "annual": "Annual",
        "monthly": "Monthly"
      },
      "contexts": {
        "pilot": "Pilot",
        "layer1": "Layer 1",
        "custom": "Custom"
      },
      "subscriptionStatus": "Subscription status"
    }
  }
}
